export const conditions = ["A", "B", "C", "D", "N"];
